import Vue from "vue";
import VueLog from "@dreipol/vue-log";
import {indexOf} from "lodash";

window.$ = window.jQuery = require('jquery');
require('bootstrap-sass');
require('./google-autocomplete');

$(document).ready(function () {
    $('[data-toggle="tooltip"]').tooltip();
});

//Vue
const debug = process.env.NODE_ENV !== 'production';
Vue.use(VueLog, {
    filter({config, level}) {
        let levels = debug ? ['debug', 'log', 'info', 'warn', 'error'] : ['warn', 'error'];
        return indexOf(levels, level.name) >= 0;
    }
});
window.Log = Vue.log();

Vue.component('multiselect', require('vue-multiselect').default);
Vue.component('multiselect-field', require('../vue/shared/MultiselectField.vue'));

const app = new Vue({
    el: '#app',
    delimiters: ['_yabble_xss_prevention_vue_delimiter_', '_yabble_xss_prevention_vue_delimiter_'],
    created() {
        Log.log('[form] - created()')
    },
});



// WEBPACK FOOTER //
// ./modules/Core/Assets/js/form.js